import { graphql, useStaticQuery } from 'gatsby';

import { useMemo } from 'react';

export const useAllProducts = () => {
    const queryResult = useStaticQuery<{
        [key: string]: { nodes: any[] };
    }>(graphql`
        query {
            allProducts: allProductsJson {
                nodes {
                    code
                    category
                    images {
                        en_CA
                        fr_CA
                        en_US
                    }
                    slug {
                        en_CA
                        fr_CA
                        en_US
                    }
                    title {
                        en_CA
                        en_US
                        fr_CA
                    }
                    description {
                        valuesMarkdownRemark {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    documents {
                        en_CA
                        en_US
                        fr_CA
                    }
                    fields {
                        ...productsFieldsImagesFragment
                    }
                    category_localized {
                        en_CA
                        en_US
                        fr_CA
                    }
                    attributes {
                        available_country {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                        size {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                    }
                }
            }
        }
    `);

    return useMemo(() => {
        const { allProducts } = queryResult;
        return [allProducts] as const;
    }, [queryResult]);
};
